export const endpoints = {
  edit: ({ vendorID, itemID, payload, onSuccess }) => ({
    url: `/admin/vendor-numbers/${vendorID}/${itemID}`,
    payload,
    list: false,
    onSuccess,
  }),
};
